var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"create-journal-button-container",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['fas', 'plus']}}),_c('span',{staticClass:"text"},[_vm._v("学習活動を作る")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }